import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { getUnique } from '../../../helpers/common'
import { useHandshakesWidget } from '../../common/widget/useHandshakesWidget'
import { FILTER_BY } from '../../constant'
import { createConnectionMapLogs } from '../../store/thunk'
import { changeLoading, changeRequestId, selectLoading } from '../store/slice'

const InvesteeMapTab = ({ filterBy, filter = {} }) => {
  const dispatch = useDispatch()
  const { graphType, searchCompany, searchPerson } = filter
  const loading = useSelector(selectLoading('investee'))
  const widgetInstance = useHandshakesWidget('#hs-widget-investee-map')

  useEffect(() => {
    if (
      widgetInstance &&
      (searchCompany?.organizationId || searchPerson?.personId)
    ) {
      const id = getUnique()
      const datasets = ['CRVN']
      const entities = [
        {
          dataset: 'CRVN',
          id:
            filterBy === FILTER_BY.COMPANY
              ? `O-${searchCompany?.organizationId}`
              : `P-${searchPerson?.personId}`,
        },
      ]
      dispatch(
        createConnectionMapLogs({
          requestId: id,
          graphType,
          datasets: JSON.stringify(datasets),
          entities: JSON.stringify(entities),
        }),
      )
      dispatch(changeRequestId({ [graphType]: id }))
      dispatch(changeLoading({ investee: true }))
      widgetInstance.drawGraphWithEndpointData({
        graphType,
        datasets,
        entities,
        degree: 1,
      })
    }
  }, [
    graphType,
    searchCompany?.organizationId,
    searchPerson?.personId,
    widgetInstance,
  ])

  if (!searchCompany?.organizationId && !searchPerson?.personId) {
    return (
      <Element
        className="textCenter pt5 fw500"
        style={{ fontSize: 20, color: '#9C9C9C' }}
      >
        <Translate value="connectMap.entityMap.PLEASE_SELECT" />
      </Element>
    )
  }

  return (
    <>
      <div id="hs-widget-investee-map" className="h100" />
      {loading && <Loading style={{ background: '#fff' }} />}
    </>
  )
}

export default InvesteeMapTab
